import React, { useEffect } from 'react';

const TermosPrivacidade = () => {
  useEffect(() => {
    // cria um style tag só para esta página
    const style = document.createElement('style');
    style.innerHTML = `
      header {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    // cleanup ao sair da página
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <iframe
        src="/termos-de-uso-politica-privacidade.pdf"
        title="Termos de Uso e Política de Privacidade"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default TermosPrivacidade;
